<template>
  <div class="page">
    <div class="layout">
      <el-row type="flex" align="middle" justify="space-between">
        <el-col :span="8">
          <div class="page-title">學生帳號列表</div>
        </el-col>
        <el-col :span="16" style="text-align: right;">
          <el-button size="mini" type="info" class="button-el-el" @click="batchTags">批量設置標簽</el-button>
          <el-button size="mini" type="info" v-if="userInfoRoleRoleId !== teacherRoleId" class="button-el-el" @click="batchSelect">批量轉校HQ</el-button>
          <el-button size="mini" type="info" @click="onDownload" class="button-el-el">下載</el-button>
        </el-col>
      </el-row>
      <div class="page-content">
        <div class="page-box">
          <div class="page-content-row">
            <div >
              <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="listQuery.tagsLike"
                  :fetch-suggestions="querySearch"
                  placeholder="請輸入老師標籤"
                  @select="handleSelect">
                <i
                    class="el-icon-edit el-input__icon"
                    slot="suffix"
                    @click="handleIconClick">
                </i>
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                </template>
              </el-autocomplete>
            </div>
            <div >
              <el-input
                v-model="listQuery.userNoLike"
                placeholder="學生帳號"
              ></el-input>
            </div>
            <div >
              <el-input
                v-model="listQuery.nameLike"
                placeholder="學生姓名"
              ></el-input>
            </div>
            <div >
              <el-select v-model="listQuery.gradeId" clearable placeholder="全部年級">
                <el-option
                  v-for="(item, index) in grades"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <el-input
                  v-model="listQuery.parentEmailLike"
                  placeholder="搜尋電郵地址"
              ></el-input>
            </div>
            <div >
              <el-select
                  v-model="listQuery.branchSchoolId"
                  clearable
                  placeholder="請選擇分校"
              >
                <el-option
                    v-for="(item, index) in sortBranchesList"
                    :key="index"
                    :label="item.abbreviation"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div >
              <el-input
                  v-model="listQuery.studentCodeLike"
                  placeholder="分校學生編號"
              ></el-input>
            </div>
            <div>
              <el-button size="mini" type="info" class="button-el-el" @click.native="onSearch">搜尋</el-button>
            </div>
          </div>
        </div>

        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column> <!-- 添加复选框列 -->
          <el-table-column label="#" type="index" width="40"></el-table-column>
          <el-table-column prop="branchSchoolId" label="分校" align="center" sortable="custom">
            <template slot-scope="{ row }">
              <span v-if="row.branchSchool">{{ row.branchSchool.abbreviation }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gradeId" label="年級" align="center" sortable="custom">
            <template slot-scope="{ row }">
              <span v-if="row.grade">{{ row.grade.name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="userNo"
            label="學生帳號"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="學生姓名"
            align="center"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column
            prop="status"
            label="帳號狀態"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{ row }">
              <span :class="{'studentCode': row.status==1,'isStudentCode':row.status==0}">{{ row.status | studentCodeStatus }}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="status"
              label="訂閱狀態"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{ row }">
              <span :class="{'studentCode': row.subscriptionStatus==1,'isStudentCode':row.subscriptionStatus==0}">
                {{ row.subscriptionStatus | subscriptionStatus }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="studentCode"
            label="分校學生編號"
            align="center"
            sortable="custom"
          >
          </el-table-column>

          <el-table-column
            prop="parentEmail"
            label="用戶電郵地址"
            align="center"
            sortable="custom"
          >
          <template slot-scope="{row}">
               <span>{{row.parentEmail}}</span>
          </template>
          </el-table-column>
          <el-table-column
              prop="studying"
              label="課程"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{row}">
              <span>{{row.studying==0?'繁':'en'}}</span>
            </template>
          </el-table-column>
          <el-table-column
              label="老師標籤"
              align="center"
          >
            <!-- 已选标签展示 -->
            <template slot-scope="scope">
              <div class="tags-container">
                <!-- 如果 tags 包含逗号 -->
                <div v-if="scope.row.tags?.indexOf(',')">
                  <el-tag
                      v-for="tag in scope.row.tags.split(',').map(tag => tag.trim())"
                      :key="tag"
                      closable
                      @close="handleTagClose(scope.row,tag)"
                      class="tag-item"
                  >
                    {{ tag }}
                  </el-tag>
                </div>

                <!-- 如果 tags 不包含逗号 -->
                <div v-else-if="scope.row.tags !== null">
                  <el-tag
                      closable
                      @close="handleTagClose(scope.row,scope.row.tags)"
                      class="tag-item"
                  >
                    {{ scope.row.tags }}
                  </el-tag>
                </div>

              </div>
            </template>

          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                v-if="adminUserInfoRoleId != teacherRoleId"
                size="medium"
                @click="onEditorButton(scope.row)"
                >編輯</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(scope.row.parentId)"
                >詳情</el-button
              >
              <el-button
                type="text"
                size="medium"
                @click="goToLearningPerformance(scope.row.id,scope.row.userNo,scope.row.studying,scope.row.grade?.id ?? 1)"
                >學習表現</el-button
              >
              <!-- 触发弹窗的按钮 -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <!-- 自定义弹窗（标签输入框 + 表单校验） -->
        <el-dialog
            title="輸入老師標籤"
            :visible.sync="dialogVisible"
            width="1200px"
            :before-close="handleDialogClose"
        >
          <el-form :model="tagForm" ref="tagFormRef">
            <el-form-item label="標籤" prop="tag" label-width="60px">
              <el-autocomplete
                  popper-class="my-autocomplete"
                  v-model="tagForm.tags"
                  :fetch-suggestions="querySearch"
                  placeholder="請輸入老師標籤"
                  @select="handleSelect"
                  style="width: 99%">
                <i
                    class="el-icon-edit el-input__icon"
                    slot="suffix"
                    @click="handleIconClick">
                </i>
                <template slot-scope="{ item }">
                  <div class="name">{{ item.value }}</div>
                </template>
              </el-autocomplete>
              <div class="form-hint">提示：多個標籤之間用英文逗號（,）分隔</div>
              <div class="page-content">
                <div class="page-box">
                  <div class="page-content-row2">
                    <div>
                      <div class="search-text">老師帳號</div>
                      <el-input
                          v-model="formLabelAlign.userNoLike"
                          placeholder=""
                          @change="getTeachers"
                      clearable
                      @input="handleInputDebounce"
                      ></el-input>
                    </div>
                    <div>
                      <div class="search-text">老師姓名</div>
                      <el-input
                          v-model="formLabelAlign.nameLike"
                          placeholder=""
                      ></el-input>
                    </div>
                    <div>
                      <el-button type="info" @click="getTeachers" class="button-el-el"
                      >搜尋</el-button
                      >
                      <el-button type="primary" @click="handleSubmit" class="button-el-el">確定</el-button>
                    </div>
                  </div>
                </div>
                <el-table :data="teacherTableData">
                  <el-table-column label="#" type="index" width="50"> </el-table-column>
                  <el-table-column
                      prop="userNo"
                      label="職員帳號"
                      align="center"
                      sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="name"
                      label="姓名"
                      align="center"
                      sortable="custom"
                  >
                  </el-table-column>
                  <el-table-column
                      prop="branchSchoolId"
                      label="分校"
                      align="center"
                      sortable="custom"
                  >
                    <template slot-scope="{ row }">
              <span v-if="row.branchSchool">{{
                  row.branchSchool.abbreviation
                }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="{ row }">
                      <el-button type="text" size="medium" @click="selectTeacherName(row)"
                      >選擇</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">確定</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery._page"
      :limit.sync="listQuery._limit"
      @pagination="getUsers"
    />
  </div>
</template>

<script>
import {changeSchools, editTags, getUsers,getTags} from "@/api/users";
import Pagination from "@/components/Pagination";
import {downloadFile} from "@/utils/is-rules";
import {getStudentReport} from "@/api/report";
import {getGrades} from '@/api/grade'

export default {
  components: {Pagination },
  filters: {
    studentCodeStatus(v) {
      return v === 0 ? "封鎖" : "生效";
    },
    subscriptionStatus(v) {
      return v === 0 ? "無訂閱" : v === 1 ? "訂閱中" : v === 2 ? "過期" : "等待開始";
    },
  },
  data() {
    return {
      restaurants: [],
      state: '',
      selectedRows: [],
      total: 0,
      userId: null,
      listQuery: {
        tagsLike: null,
        userNoLike: null,
        nameLike: null,
        parentEmailLike: null,
        studentCodeLike: null,
        gender: null,
        gradeId: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      centerDialogVisible: false,
      dialogSlotVisible: false,
      tableData: [],
      avatars: [],
      grades: [],
      form: {
        ids: null,
      },
      dialogVisible: false, // 弹窗显示状态
      tagForm: {
        tags: '',
        ids: null,
        del: 0
      },
      rules: {
        // 表单校验规则（必填）
        tags: [
          { required: true, message: '请输入标签', trigger: 'blur' }
        ]
      },
      tags: null,
      allTag: "",
      tagsUserId: null,
      formLabelAlign: {
        type: 0,
        userNoLike: null,
        nameLike: null,
        emailLike: null,
        roleId: null,
        phoneLike: null,
        branchSchoolId: null,
        gender: null,
        orderBy: null,
        _page: 1,
        _limit: 50,
      },
      teacherTableData: [],
      teacherTableDataTotal: 0
    };
  },
  created() {
    this.getUsers();
    this.getGrades();
    this.getTags();
  },
  methods: {
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      console.log(item);
    },
    handleIconClick(ev) {
      console.log(ev);
    },
    // 打开弹窗
    openDialog(row) {
      this.getTeachers();
      this.tags = row.tags;
      this.tagsUserId = row.id;
      // 清空输入框和校验状态
      this.tagForm.tags = '';
      this.$nextTick(() => {
        this.$refs.tagFormRef?.clearValidate();
      });
      this.dialogVisible = true;
    },

    // 关闭弹窗（清空输入框和校验）
    handleDialogClose() {
      this.tagForm.tags = '';
      this.tagForm.ids = null;
      this.$refs.tagFormRef?.clearValidate();
      this.dialogVisible = false;
      this.getUsers();
    },

    // 提交标签（表单校验 + 处理标签数据）
    handleSubmit() {
      this.$refs.tagFormRef.validate(valid => {
        if (valid) {
          editTags(this.tagForm).then(() => {
            this.$message.success("標籤設置成功！");
            this.getUsers();
            this.getGrades();
          });
          // 关闭弹窗
          this.dialogVisible = false;
        }
      });
    },
    batchTags() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }
      this.$nextTick(() => {
        this.$refs.tagFormRef?.clearValidate();
      });
      this.dialogVisible = true;
      // 清空输入框和校验状态
      this.tagForm.tags = '';
      this.tagForm.del = 0;
      this.tagForm.ids = this.selectedRows.map(row => row.id).join(',');
      this.getTeachers();
      this.getTags();
    },
    // 删除已选标签（处理字符串格式的 tags）
    handleTagClose(row,tagToRemove) {
      // 1. 将字符串 tags 转换为数组
      // 使用 split(',') 分割，并使用 map + trim() 去除每个标签两边的空格
      let tagsArray = row.tags.split(',').map(tag => tag.trim());

      // 2. 从数组中过滤掉要删除的标签
      // filter 会返回一个不包含 tagToRemove 的新数组
      let newTagsArray = tagsArray.filter(tag => tag !== tagToRemove);

      // 3. 将新的数组转换回字符串
      this.tags = newTagsArray.join(',');

      this.tagForm.tags=this.tags;
      this.tagForm.ids=row.id;
      this.tagForm.del=1;
      editTags(this.tagForm).then(() => {
        // 提示信息（这里可以优化一下，显示被删除的标签名）
        this.$message({
          type: 'info',
          message: `已删除标签：${tagToRemove}`
        });
      });

      console.log('删除后的 tags:', this.tags);
      // 调用 getUsers() 刷新用户列表
      this.getUsers();
    },
    // 处理复选框选择变化
    handleSelectionChange(selection) {
      this.selectedRows = selection;
      console.log('选中的行数据:', selection);
    },
    batchSelect() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('請選擇數據！');
        return;
      }
// 调用原生确认弹窗，参数为提示文本
      const isConfirm = window.confirm('您確定批量轉校這些學生嗎！')
      // 根据用户选择执行后续逻辑
      if (isConfirm) {
        // 通过事件传递选中的多行数据
        // this.$emit('batch-select', this.selectedRows);
        // 如果需要同时触发单行选择事件（可选）
        this.form.ids = this.selectedRows.map(row => row.id).join(',');
        changeSchools(this.form).then(() => {
          this.$message.success("轉校成功");
          this.getUsers();
          this.getGrades();
        });
      }

    },
    getGrades(){
      getGrades().then((res)=>{
        this.grades = res.data
      })
    },
    onDownload(){
      this.getStudentReport()
    },
    getStudentReport() {
      let form = {
        tags: this.listQuery.tagsLike || null,
        nameLike: this.listQuery.nameLike || null,
          userNoLike: this.listQuery.userNoLike || null, 
          parentEmailLike: this.listQuery.parentEmailLike || null, 
          gender: this.listQuery.gender, 
          branchSchoolId: this.listQuery.branchSchoolId || null, 
          gradeId: this.listQuery.gradeId || null, 
          studentCodeLike: this.listQuery.studentCodeLike || null
      }
      getStudentReport(form).then((res)=>{
          downloadFile(res.data,'studentReport.xlsx')
      })
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.listQuery.orderBy = column.prop + " desc";
      } else if (column.order === "ascending") {
        this.listQuery.orderBy = column.prop + " asc";
      } else {
        this.listQuery.orderBy = null;
      }
      this.listQuery._page = 1;
      this.getUsers();
    },
    onSearch() {
      this.getUsers();
    },
    onReset() {
      Object.keys(this.listQuery).forEach((key) => {
        this.listQuery[key] = null;
        if (key === "_page") {
          this.listQuery[key] = 1;
        } else if (key === "_limit") {
          this.listQuery[key] = 50;
        }
      })
      this.getUsers();
    },
    goToLearningPerformance(id,userNo,studying,gradeId) {
      let path = `/student/${id}/learning-performance/${userNo}?studying=${studying}&gradeId=${gradeId}`
      this.resolveRouter(path)
    },
    onEditorButton(row) {
      let path = `/student/${row.parentId}/edit?studentId=${row.id}&type=student`
      this.resolveRouter(path)
    },
    onAdd() {
      let path = `/student/add`
      this.resolveRouter(path)
    },
    onDetailButton(id) {
      let path = `/student/${id}`
      this.resolveRouter(path)
    },
    getUsers() {
      let listQuery = {
        type: 2,
        tags: this.listQuery.tagsLike,
        userNoLike: this.listQuery.userNoLike,
        nameLike: this.listQuery.nameLike,
        parentEmailLike: this.listQuery.parentEmailLike,
        studentCodeLike: this.listQuery.studentCodeLike,
        branchSchoolId: this.listQuery.branchSchoolId,
        gender: this.listQuery.gender,
        gradeId: this.listQuery.gradeId,
        orderBy: this.listQuery.orderBy,
        _page: this.listQuery._page - 1,
        _limit: this.listQuery._limit,
      };
      getUsers(listQuery).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
    getTags() {
      getTags().then((v) => {
        this.allTag = v.data;
        console.info(this.allTag)
        // const originalStr = '66668888,123,elvis@ktk,HQ00007,mekochan@ltn,teacher1';
// 核心转换逻辑（整合去空格+过滤空值，更简洁）
        const result = this.allTag.split(',')
            .map(item => item.trim()) // 先去除每个元素的首尾空格
            .filter(item => item) // 过滤空字符串（包括纯空格的元素）
            .map(item => ({ value: item }));

// 格式化输出（便于调试查看完整结果）
        const jsonStr = JSON.stringify(result, null, 4);
        console.info(jsonStr);

// 如果你需要返回完整转换结果（推荐）：
// return result;

// 如果你仅需要返回前2个元素（和你示例一致）：
        this.restaurants=result;
      });
    },
    // 防抖处理：输入停止 500ms 后再触发查询（避免频繁请求接口）
    handleInputDebounce() {
      if (this.inputTimer) clearTimeout(this.inputTimer);
      this.inputTimer = setTimeout(() => {
        this.getTeachers();
      }, 500);
    },
    getTeachers() {
      let listQuery = {
        type: 0,
        userNoLike: this.formLabelAlign.userNoLike,
        nameLike: this.formLabelAlign.nameLike,
        emailLike: this.formLabelAlign.emailLike,
        phoneLike: this.formLabelAlign.phoneLike,
        roleId: 2,
        gender: this.formLabelAlign.gender,
        branchSchoolId: this.formLabelAlign.branchSchoolId,
        orderBy: this.formLabelAlign.orderBy,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getUsers(listQuery).then((v) => {
        this.teacherTableData = v.data;
        this.teacherTableDataTotal = Number(v.headers["x-total-count"]);
      });
    },
    selectTeacherName(row){
      // 第一步：先校验userNo是否有效（避免拼接空值）
      const userNo = row.userNo?.trim() || '';
      if (!userNo) {
        // userNo为空时，直接终止拼接（无需处理）
        return;
      }

    // 第二步：处理tags的拼接逻辑（核心：仅用userNo，判断是否加逗号）
      if (this.tagForm.tags && this.tagForm.tags.trim()!== '') {
        // tags已有内容：加中文逗号后拼接userNo
        this.tagForm.tags = `${this.tagForm.tags},${userNo}`;
      } else {
        // tags为空：直接赋值userNo（避免开头多逗号）
        this.tagForm.tags = userNo;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.tags-container {
  margin-top: 16px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px; /* 增加标签之间的间距 */
}
.tags-title {
  font-weight: 500;
  color: #606266;
}
/* 可选：为标签添加一些过渡效果，提升用户体验 */
.tag-item {
  transition: all 0.3s ease;
}
.tag-item:hover {
  transform: scale(1.05);
}
.form-hint {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
.dialog-footer {
  text-align: right;
}
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
  .demo-ruleForm-div {
    margin-top: 40px;
  }
  ::v-deep {
    .cell {
      color: black;
    }
  }
}
.form-avatar {
  position: relative;
  width: 90px;
  height: 90px;
}
.search-text {
  margin-bottom: 12px;
  color: #8e8e8e;
}
.page-content {
  background-color: #fff;
}
.page-box{
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
}
.page-content-row {
  padding: 30px 10px;
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(1, 1fr);
    justify-items: start; /* 网格项水平靠左对齐（新增核心） */
    justify-content: start; /* 可选：容器内所有网格整体靠左，避免列宽不足时居中 */
    gap: 8px;
    align-items: end;
}
.page-content-row>div{
  min-width: 140px;
}
.page-content-row>div:nth-last-child(1){
  min-width: 120px;
  grid-column-start: 10;
  text-align: right;
}
.page-content-row>div:nth-last-child(2){
  min-width: 120px;
}
.page-content-row>div:nth-last-child(3){
  min-width: 100px;
}
.button-el-el {
  margin-top: 30px;
}
.studentCode{
  color: #027915;
}
.isStudentCode{
  color: #9C0000;
}

.page-content-row2 {
  padding: 30px 10px;
  display: grid;
  padding: 20px;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(1, 1fr);
  justify-items: start; /* 网格项水平靠左对齐（新增核心） */
  justify-content: start; /* 可选：容器内所有网格整体靠左，避免列宽不足时居中 */
  gap: 8px;
  align-items: end;
}
.page-content-row2>div{
  min-width: 140px;
}
.page-content-row2>div:nth-last-child(1){
  min-width: 120px;
  grid-column-start: 10;
  text-align: right;
}
.page-content-row2>div:nth-last-child(2){
  min-width: 120px;
}
.page-content-row2>div:nth-last-child(3){
  min-width: 100px;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
</style>